// src/redux/slices/locationSlice.js

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  locValue: '',
  transactionNumber: '',
  userId: '',
  mobileNumber: '',
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocValue: (state, action) => {
      // Spread action.payload to update the state partially
      return {
        ...state,
        ...action.payload,
      };
    },
    resetLocValue: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetAllLocValues: () => {
      return initialState;
    },
  },
});

export const {setLocValue, resetLocValue, resetAllLocValues} =
  locationSlice.actions;

export default locationSlice.reducer;
